
'use strict'

import {fetchData, getHost, sendDataFormat} from '../../common/js/util';
import requestConfig from '../../config/config'

export default {
    init: (config, resolve, reject) => {
        let url = requestConfig.LOGIN.url;
        fetchData({
            url: getHost({httpsOnly: true}) + url,
            sendData: sendDataFormat(requestConfig.LOGIN.param, config)
        }).then(
            (res) => {
                resolve(res)
            },
            (e) => { 
                reject(e)
            }
        ).catch(e => {
            reject(e)
            console.log('static page login error' + e);
        });
    }
}



// WEBPACK FOOTER //
// ./modules/top-nav/js/login.js